module.exports = __webpack_public_path__ + "fonts/ZingScriptRustR-Base.4e48b29b.ttf";